import React, { useState } from 'react';
import {
  injectStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  Elements,
  ReactStripeElements,
} from 'react-stripe-elements';

import { Box, Button, Flex, FormLabel, Text } from '../../../core-ui';

type Token = stripe.Token;

type InjectedStripePaymentFormProps = {
  formattedPrice: string;
  onSubmit: (token: Token) => Promise<void>;
};
type Props = ReactStripeElements.InjectedStripeProps &
  InjectedStripePaymentFormProps;

function StripePaymentForm(props: Props) {
  const { formattedPrice } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    const { onSubmit, stripe } = props;
    event.preventDefault();
    if (stripe && !isSubmitted) {
      setIsLoading(true);
      const { token } = await stripe.createToken();
      if (token) {
        await onSubmit(token);
      }
      setIsLoading(false);
    }
    // stop sending charges after the first until refresh form
    setIsSubmitted(true);
  };

  return (
    <Box as="form" onSubmit={handleSubmit} className="std-form embedded-form">
      <Flex flexDirection="column" gap={2}>
        <Text>
          {t(
            'To pay {formattedPrice} by credit card, use the following form.',
            { formattedPrice },
          )}
        </Text>
        <Box>
          <FormLabel>{t('Card number')}</FormLabel>
          <CardNumberElement />
        </Box>
        <Box>
          <FormLabel>{t('Expiration date')}</FormLabel>
          <CardExpiryElement />
        </Box>
        <Box>
          <FormLabel>{t('CVC')}</FormLabel>
          <CardCVCElement />
        </Box>
        <Button
          disabled={isSubmitted}
          isLoading={isLoading}
          onClick={handleSubmit}
          variant="primary"
          width="100%"
        >
          {isSubmitted ? t('Submitting Now') : t('Submit')}
        </Button>
      </Flex>
    </Box>
  );
}

const InjectedStripePaymentForm = injectStripe(StripePaymentForm);

function StripePayment(props: InjectedStripePaymentFormProps) {
  return (
    <Elements>
      <InjectedStripePaymentForm {...props} />
    </Elements>
  );
}

export default StripePayment;
